import {
  PaymentsAggregatorPaymentSystems,
  PaymentsDistributionSettingsItems,
} from '@types';

import { PaymentsReceiveGetDistributionSettingsListReducer } from './types';

export const paymentsReceiveGetDistributionSettingsListReducer: PaymentsReceiveGetDistributionSettingsListReducer =
  (state, action) => {
    const { items } = action.payload;

    const paymentsDistributionSettingsItems = items.reduce(
      (previousValue, currentValue) => {
        return {
          ...previousValue,
          [currentValue.id]: {
            aggregatorState: currentValue.state,
            lastSuccessTransactionTime: currentValue.lastSuccessTransactionTime,
            paymentSystems: currentValue.paymentSystems.reduce(
              (previousValue, currentValue) => {
                return currentValue
                  ? {
                      ...previousValue,
                      [currentValue.id]: {
                        paymentSystemState: currentValue.state,
                        distributionPercent: currentValue.distributionPercent,
                      },
                    }
                  : previousValue;
              },
              {} as PaymentsAggregatorPaymentSystems
            ),
          },
        };
      },
      {} as PaymentsDistributionSettingsItems
    );

    return {
      ...state,
      paymentsDistributionSettingsItems,
    };
  };
